<template>
  <div class="d-inline-block position-relative chart">
    <img
      src="@/assets/supportToEconomy/demo1_bg-c.jpg"
      alt=""
      class="img-fluid align-top"
      v-if="$i18n.locale == 'zh'"
    />
    <img src="@/assets/supportToEconomy/demo1_bg.jpg" alt="" class="img-fluid align-top" v-else />
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1420 554" class="position-absolute line">
      <defs></defs>
      <polyline
        class="cls-1"
        points="97.5 459.66 176.93 448.97 262.97 402.13 352.07 334.41 435.57 248.88 522.12 245.82 605.11 233.09 690.13 212.73 774.14 219.35 861.71 129.23 948.26 233.09 1036.85 211.71 1130.02 207.13 1223.19 130.25 1309.24 131.27 1415.65 85.95"
      />
    </svg>
    <div class="position-absolute dots">
      <div class="dot dot-0">
        <div class="text">30%</div>
      </div>
      <div class="dot dot-1">
        <div class="text">32%</div>
      </div>
      <div class="dot dot-2">
        <div class="text">35%</div>
      </div>
      <div class="dot dot-3">
        <div class="text">42%</div>
      </div>
      <div class="dot dot-4">
        <div class="text">48%</div>
      </div>
      <div class="dot dot-5">
        <div class="text">49%</div>
      </div>
      <div class="dot dot-6">
        <div class="text">50%</div>
      </div>
      <div class="dot dot-7">
        <div class="text">53%</div>
      </div>
      <div class="dot dot-8">
        <div class="text">52%</div>
      </div>
      <div class="dot dot-9">
        <div class="text">59%</div>
      </div>
      <div class="dot dot-10">
        <div class="text">50%</div>
      </div>
      <div class="dot dot-11">
        <div class="text">52%</div>
      </div>
      <div class="dot dot-12">
        <div class="text">53%</div>
      </div>
      <div class="dot dot-13">
        <div class="text">59%</div>
      </div>
      <div class="dot dot-14">
        <div class="text">59%</div>
      </div>
      <div class="dot dot-15">
        <div class="text">62%</div>
      </div>
      <div class="text-label" v-if="$i18n.locale == 'zh'">
        「旅遊 · 就在香港」推出
      </div>
      <div class="text-label" v-else>
        Holiday at Home Launched
      </div>
    </div>
  </div>
</template>

<script>
import { gsap, Linear } from "gsap";

export default {
  props: { testProp: Boolean },
  data() {
    return {
      graph: Object,
      seen: false,
    };
  },
  methods: {
    rolling() {
      let property = {
        value: 1520,
      };
      this.seen = true;
      this.graph = gsap.to(property, 5, {
        value: 0,
        ease: Linear.easeNone,
        onUpdate: function() {
          document.querySelector(".cls-1").style.strokeDashoffset = property.value;
          if (property.value < 1520) {
            document.querySelector(".dot-0").classList.add("d-block");
            document.querySelector(".dot-0 .text").style.display = "block";
          }
          if (property.value < 1440) {
            document.querySelector(".dot-1").classList.add("d-block");
          }
          if (property.value < 1340) {
            document.querySelector(".dot-2").classList.add("d-block");
          }
          if (property.value < 1235) {
            document.querySelector(".dot-3").classList.add("d-block");
            document.querySelector(".text-label").classList.add("d-block");
          }
          if (property.value < 1110) {
            document.querySelector(".dot-4").classList.add("d-block");
          }
          if (property.value < 1025) {
            document.querySelector(".dot-5").classList.add("d-block");
          }
          if (property.value < 940) {
            document.querySelector(".dot-6").classList.add("d-block");
          }
          if (property.value < 850) {
            document.querySelector(".dot-7").classList.add("d-block");
          }
          if (property.value < 770) {
            document.querySelector(".dot-8").classList.add("d-block");
          }
          if (property.value < 643) {
            document.querySelector(".dot-9").classList.add("d-block");
          }
          if (property.value < 505) {
            document.querySelector(".dot-10").classList.add("d-block");
          }
          if (property.value < 415) {
            document.querySelector(".dot-11").classList.add("d-block");
          }
          if (property.value < 322) {
            document.querySelector(".dot-12").classList.add("d-block");
          }
          if (property.value < 200) {
            document.querySelector(".dot-13").classList.add("d-block");
          }
          if (property.value < 113) {
            document.querySelector(".dot-14").classList.add("d-block");
          }
          if (property.value < 7) {
            document.querySelector(".dot-15").classList.add("d-block");
            document.querySelector(".dot-15 .text").style.display = "block";
          }
        },
      });
    },
  },
  watch: {
    testProp: function(newVal, oldVal) {
      this.rolling();
    },
  },
  mounted() {},
  beforeDestroy() {
    if (this.seen == true) {
      this.graph.pause();
    }
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: none;
  stroke: #e81929;
  stroke-miterlimit: 10;
  stroke-width: 5px;
  stroke-dasharray: 1520;
  stroke-dashoffset: 1520;
}
.line {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.dots {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.dot {
  display: none;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  transform: translate(-50%, -50%);
  background-color: #e81929;
}
.dot:hover .text {
  display: block;
}
.dot .text {
  display: none;
  position: absolute;
  color: #e81929;
  font-size: 1.25rem;
  font-weight: 700;
  bottom: 20px;
  left: 110%;
  transform: translateX(-50%);
}
.dot-0 {
  top: 82.8%;
  left: 6.9%;
  width: 20px;
  height: 20px;
  border-radius: 10px;
}
.dot-1 {
  top: 80.9%;
  left: 12.5%;
}
.dot-2 {
  top: 72.3%;
  left: 18.6%;
}
.dot-3 {
  top: 60.6%;
  left: 24.6%;
}
.dot-4 {
  top: 44.9%;
  left: 30.6%;
}
.dot-5 {
  top: 44.3%;
  left: 36.7%;
}
.dot-6 {
  top: 42%;
  left: 42.5%;
}
.dot-7 {
  top: 38.5%;
  left: 48.6%;
}
.dot-8 {
  top: 39.4%;
  left: 54.5%;
}
.dot-9 {
  top: 23.4%;
  left: 60.7%;
}
.dot-10 {
  top: 42.1%;
  left: 66.9%;
}
.dot-11 {
  top: 38.2%;
  left: 73.1%;
}
.dot-12 {
  top: 37.2%;
  left: 79.6%;
}
.dot-13 {
  top: 23.5%;
  left: 86.2%;
}
.dot-14 {
  top: 23.5%;
  left: 92.3%;
}
.dot-15 {
  top: 15.9%;
  left: 99.3%;
  width: 20px;
  height: 20px;
  border-radius: 10px;
}
.dot-0 .text,
.dot-15 .text {
  font-size: 2rem;
  left: 50%;
  transform: translateX(-25%);
}
.dot-2 .text,
.dot-3 .text,
.dot-8 .text {
  left: 25%;
  transform: translateX(-50%);
}
.dot-10 .text {
  left: 25%;
  transform: translateX(-15%);
}
.dot-12 .text {
  left: 25%;
}
.text-label {
  display: none;
  position: absolute;
  top: 64.2%;
  left: 26.5%;
  background-color: #e81929;
  color: #ffffff;
  text-transform: uppercase;
  padding: 10px 20px;
  font-size: 1.25rem;
}
.text-label:before {
  content: "";
  position: absolute;
  top: -6px;
  left: -13px;
  transform: rotate(57deg);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 25px 25px 25px;
  border-color: transparent transparent #e81929 transparent;
}

@media (max-width: 991px) {
  .dot {
    width: 9px;
    height: 9px;
  }
  .dot-0,
  .dot-15 {
    width: 14px;
    height: 14px;
    .text {
      font-size: 1.6rem;
    }
  }
  .text-label {
    left: 26.6%;
    padding: 8px 18px;
  }
  .text-label:before {
    top: -15px;
    left: -6px;
    border-width: 0 0px 25px 25px;
    transform: rotate(62deg);
  }
}
@media (max-width: 767px) {
  .dot-15 {
    .text {
      left: -30%;
    }
  }
  .text-label {
    top: 54.2%;
    left: 31.6%;
  }
  .text-label:before {
    top: -2px;
    left: -23px;
    border-width: 6px 10px 25px 10px;
    transform: rotate(-80deg);
  }
}
@media (max-width: 575px) {
  .dot {
    width: 6px;
    height: 6px;
  }
  .dot-0,
  .dot-15 {
    width: 9px;
    height: 9px;
    .text {
      font-size: 1.4rem;
    }
  }
  .dot-15 {
    .text {
      left: -160%;
      bottom: 100%;
    }
  }
  .text-label {
    font-size: 1rem;
  }
}
@media (max-width: 450px) {
  .text-label {
    padding: 6px 10px;
  }
}
@media (max-width: 320px) {
  .text-label {
    top: 49.2%;
    left: 35.6%;
    padding: 5px 10px;
    font-size: 0.9rem;
  }
  .dot-0,
  .dot-15 {
    .text {
      font-size: 1.2rem;
    }
  }
  .dot-0 {
    .text {
      left: 95%;
    }
  }
  .text-label:before {
    top: 0px;
    border-width: 5px 10px 25px 10px;
    transform: rotate(-90deg);
  }
}
</style>
